import * as React from "react";
import Paper from "@material-ui/core/Paper";

export type SurfaceProps = React.HTMLAttributes<HTMLElement>;

// A raised panel. Its background beats a Tailwind bg-* class, so set colours through `style`.
export const Surface: React.FC<SurfaceProps> = (props) => (
  <Paper {...(props as React.HTMLAttributes<HTMLDivElement>)} />
);
